import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import type { AdItem } from '@sbt-web/network/types';
import { AdItemCardMini } from '@sbt-web/item-card';
type Props = {
  adItem: AdItem;
  index: number;
  isProfileOwner: boolean;
};
const CardComponent = t0 => {
  const $ = _c(4);
  const {
    adItem,
    index,
    isProfileOwner
  } = t0;
  const t1 = index > 6;
  let t2;
  if ($[0] !== adItem || $[1] !== isProfileOwner || $[2] !== t1) {
    t2 = <AdItemCardMini item={adItem} aspectRatio="4/5" imageSizeType="responsive" assetsBase={process.env.NEXT_PUBLIC_ASSETS_BASE_URL} lazyLoad={t1} disableFavourite={isProfileOwner} />;
    $[0] = adItem;
    $[1] = isProfileOwner;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export const Card = memo<Props>(CardComponent);
Card.displayName = 'Card';